export const FormOrWorkflowName = 'FormOrWorkflowComponent';
